import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=7e5182c5&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7e5182c5', component.options)
    } else {
      api.reload('7e5182c5', component.options)
    }
    module.hot.accept("./Tag.vue?vue&type=template&id=7e5182c5&", function () {
      api.rerender('7e5182c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Tag.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Tag.vue
// module id = HIsw
// module chunks = 0